import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Play } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
type CardProps = {
  showNotification?: boolean;
};
export function ClientPanelCard({
  showNotification = true
}: CardProps) {
  const {
    lang
  } = useLanguage();
  const tags = lang === 'es' ? ['LLC formada', 'EIN obtenido', 'Landing activa'] : ['LLC formed', 'EIN obtained', 'Landing active'];
  return <div style={{
    position: 'relative'
  }} data-id="element-238">
      {showNotification && <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="flex items-center" style={{
      background: '#5a4579',
      color: '#FFFFFF',
      borderRadius: '11px',
      padding: '11px 14px',
      gap: '12px',
      boxShadow: '0 10px 30px rgba(90,69,121,0.3)',
      marginBottom: '14px',
      position: 'relative',
      zIndex: 2
    }} data-id="element-239">
          <div className="flex items-center justify-center flex-shrink-0" style={{
        width: '32px',
        height: '32px',
        minWidth: '32px',
        background: 'rgba(255,255,255,0.15)',
        borderRadius: '9px'
      }} data-id="element-240">
            <Check size={16} strokeWidth={2.6} color="#FFFFFF" data-id="element-241" />
          </div>
          <div style={{
        minWidth: 0
      }} data-id="element-242">
            <div style={{
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: 1.25
        }} data-id="element-243">
              {lang === 'es' ? 'Nueva empresa registrada' : 'New company registered'}
            </div>
            <div style={{
          fontSize: '10px',
          color: 'rgba(255,255,255,0.65)',
          marginTop: '2px'
        }} data-id="element-244">
              {lang === 'es' ? 'hace 2 horas · Miami, FL' : '2 hours ago · Miami, FL'}
            </div>
          </div>
        </motion.div>}

      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: showNotification ? 0.55 : 0.1
    }} className="transition-all" style={{
      background: '#FFFFFF',
      borderRadius: '16px',
      padding: '22px',
      boxShadow: '0 8px 40px rgba(90,69,121,0.08)',
      position: 'relative',
      overflow: 'hidden'
    }} data-id="element-245">
        {/* Dot pattern */}
        <div aria-hidden="true" style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 4px)',
        gridTemplateRows: 'repeat(3, 4px)',
        gap: '8px'
      }} data-id="element-246">
          {Array.from({
          length: 12
        }).map((_, i) => <span key={i} style={{
          width: '4px',
          height: '4px',
          background: 'rgba(90,69,121,0.12)',
          borderRadius: '50%',
          display: 'block'
        }} data-id="element-247" />)}
        </div>

        {/* Avatar + name */}
        <div className="flex items-center" style={{
        gap: '12px',
        marginBottom: '16px'
      }} data-id="element-248">
          <div className="flex items-center justify-center flex-shrink-0" style={{
          width: '42px',
          height: '42px',
          minWidth: '42px',
          background: '#5a4579',
          color: '#FFFFFF',
          borderRadius: '50%',
          fontWeight: 800,
          fontSize: '14px',
          letterSpacing: '0.5px'
        }} data-id="element-249">
            MC
          </div>
          <div style={{
          minWidth: 0
        }} data-id="element-250">
            <div style={{
            fontSize: '13px',
            fontWeight: 700,
            color: '#1a1020',
            lineHeight: 1.25
          }} data-id="element-251">
              María C. — {lang === 'es' ? 'cliente activa' : 'active client'}
            </div>
            <div style={{
            fontSize: '11px',
            color: '#9580aa',
            marginTop: '2px'
          }} data-id="element-252">
              E-commerce · Miami, FL
            </div>
          </div>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap" style={{
        gap: '6px',
        marginBottom: '18px'
      }} data-id="element-253">
          {tags.map((t, i) => <span key={i} className="inline-flex items-center" style={{
          background: 'rgba(15,110,86,0.09)',
          color: '#0F6E56',
          borderRadius: '999px',
          padding: '4px 9px 4px 7px',
          fontSize: '11px',
          fontWeight: 700,
          gap: '4px'
        }} data-id="element-254">
              <Check size={11} strokeWidth={3} data-id="element-255" />
              {t}
            </span>)}
        </div>

        {/* Progress */}
        <div style={{
        marginBottom: '16px'
      }} data-id="element-256">
          <div className="flex items-center justify-between" style={{
          marginBottom: '6px'
        }} data-id="element-257">
            <span style={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#6b5f78'
          }} data-id="element-258">
              {lang === 'es' ? 'Progreso del plan' : 'Plan progress'}
            </span>
            <span style={{
            fontSize: '12px',
            fontWeight: 800,
            color: '#5a4579'
          }} data-id="element-259">
              75%
            </span>
          </div>
          <div style={{
          position: 'relative',
          height: '5px',
          background: 'rgba(90,69,121,0.08)',
          borderRadius: '999px',
          overflow: 'visible'
        }} data-id="element-260">
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '75%'
          }} transition={{
            duration: 0.9,
            delay: 0.7,
            ease: 'easeOut'
          }} style={{
            height: '100%',
            background: 'linear-gradient(90deg, #5a4579 0%, #9580aa 100%)',
            borderRadius: '999px',
            position: 'relative'
          }} data-id="element-261">
              <span aria-hidden="true" style={{
              position: 'absolute',
              right: '-5px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '10px',
              height: '10px',
              background: '#FFFFFF',
              borderRadius: '50%',
              boxShadow: '0 0 0 4px rgba(149,128,170,0.25), 0 1px 4px rgba(90,69,121,0.35)'
            }} data-id="element-262" />
            </motion.div>
          </div>
        </div>

        {/* Mini-cards */}
        <div className="grid grid-cols-2" style={{
        gap: '10px'
      }} data-id="element-263">
          <div style={{
          background: '#f7f4fb',
          borderRadius: '10px',
          padding: '12px'
        }} data-id="element-264">
            <div style={{
            fontSize: '10px',
            fontWeight: 700,
            color: '#9580aa',
            letterSpacing: '0.3px',
            textTransform: 'uppercase',
            marginBottom: '4px'
          }} data-id="element-265">
              {lang === 'es' ? 'Empresa registrada' : 'Company registered'}
            </div>
            <div style={{
            fontSize: '17px',
            fontWeight: 800,
            color: '#1a1020',
            lineHeight: 1.1
          }} data-id="element-266">
              {lang === 'es' ? '7 días' : '7 days'}
            </div>
            <div style={{
            fontSize: '10px',
            color: '#0F6E56',
            marginTop: '3px',
            lineHeight: 1.3,
            fontWeight: 600
          }} data-id="element-267">
              {lang === 'es' ? 'promedio de entrega' : 'average delivery'}
            </div>
          </div>
          <div style={{
          background: '#f7f4fb',
          borderRadius: '10px',
          padding: '12px'
        }} data-id="element-268">
            <div style={{
            fontSize: '10px',
            fontWeight: 700,
            color: '#9580aa',
            letterSpacing: '0.3px',
            textTransform: 'uppercase',
            marginBottom: '4px'
          }} data-id="element-269">
              {lang === 'es' ? 'Próximo paso' : 'Next step'}
            </div>
            <div style={{
            fontSize: '14px',
            fontWeight: 800,
            color: '#5a4579',
            lineHeight: 1.2
          }} data-id="element-270">
              {lang === 'es' ? 'Cuenta bancaria' : 'Bank account'}
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}
export function HeroSection() {
  const {
    lang
  } = useLanguage();
  const stats = [{
    value: '100+',
    label: lang === 'es' ? 'negocios lanzados' : 'businesses launched'
  }, {
    value: '100%',
    label: lang === 'es' ? 'satisfacción' : 'satisfaction'
  }, {
    value: lang === 'es' ? '< 2 sem' : '< 2 wks',
    label: lang === 'es' ? 'tiempo de entrega' : 'delivery time'
  }];
  return <section className="hero-section" style={{
    background: '#f0ecf8',
    position: 'relative',
    overflow: 'hidden',
    padding: '96px 24px 56px'
  }} data-id="element-271">
      <style data-id="element-272">{`
        @media (min-width: 769px) {
          .hero-section { padding: 120px 40px 80px !important; }
          .hero-orb-lg { display: block !important; }
          .hero-grid { grid-template-columns: 55% 45% !important; }
        }
      `}</style>

      {/* Orb 1 */}
      <div aria-hidden="true" className="absolute pointer-events-none hero-orb-lg" style={{
      display: 'none',
      top: '-180px',
      right: '-150px',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(90,69,121,0.13) 0%, rgba(90,69,121,0) 70%)',
      zIndex: 0
    }} data-id="element-273" />
      {/* Orb 2 */}
      <div aria-hidden="true" className="absolute pointer-events-none hero-orb-lg" style={{
      display: 'none',
      bottom: '-120px',
      left: '-100px',
      width: '320px',
      height: '320px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(90,69,121,0.09) 0%, rgba(90,69,121,0) 70%)',
      zIndex: 0
    }} data-id="element-274" />
      {/* Orb 3 */}
      <div aria-hidden="true" className="absolute pointer-events-none" style={{
      top: '40%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '200px',
      height: '200px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(180,158,214,0.10) 0%, rgba(180,158,214,0) 70%)',
      zIndex: 0
    }} data-id="element-275" />

      <div className="max-w-6xl mx-auto" style={{
      position: 'relative',
      zIndex: 1
    }} data-id="element-276">
        <div className="hero-grid grid gap-10 md:gap-14 items-center" style={{
        gridTemplateColumns: '1fr'
      }} data-id="element-277">
          {/* LEFT — Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="hero-left" data-id="element-278">
            <style data-id="element-279">{`
              .hero-left { text-align: center; }
              .hero-left .hero-badge,
              .hero-left .hero-stats { justify-content: center; }
              .hero-left .hero-ctas { align-items: stretch; }
              @media (min-width: 769px) {
                .hero-left { text-align: left; }
                .hero-left .hero-badge,
                .hero-left .hero-stats { justify-content: flex-start; }
              }
            `}</style>

            {/* Badge */}
            <div className="inline-flex items-center hero-badge" style={{
            background: 'rgba(255,255,255,0.7)',
            border: '0.5px solid rgba(90,69,121,0.25)',
            borderRadius: '99px',
            padding: '6px 16px',
            gap: '6px',
            marginBottom: '20px',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)'
          }} data-id="element-280">
              <span style={{
              fontSize: '12px',
              fontWeight: 600,
              color: '#5a4579',
              letterSpacing: '0.2px'
            }} data-id="element-281">
                {lang === 'es' ? '✦ De la idea al negocio digital que genera resultados' : '✦ From idea to a digital business that delivers results'}
              </span>
            </div>

            {/* Headline */}
            <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(32px, 5.5vw, 52px)',
            fontWeight: 700,
            color: '#1a1020',
            lineHeight: 1.1,
            letterSpacing: '-0.5px',
            marginBottom: '20px'
          }} data-id="element-282">
              {lang === 'es' ? <>
                  Tu negocio necesita una{' '}
                  <span className="italic" style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: 'italic',
                fontWeight: 600,
                color: '#5a4579'
              }} data-id="element-283">
                    base digital real
                  </span>
                  . La construimos contigo.
                </> : <>
                  Your business needs a{' '}
                  <span className="italic" style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: 'italic',
                fontWeight: 600,
                color: '#5a4579'
              }} data-id="element-284">
                    real digital foundation
                  </span>
                  . We build it with you.
                </>}
            </h1>

            {/* Subtitle */}
            <p style={{
            fontSize: '15px',
            color: '#6b5f78',
            lineHeight: 1.65,
            marginBottom: '24px',
            maxWidth: '560px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }} data-id="element-285">
              {lang === 'es' ? 'Empresa en USA, presencia online profesional y todo listo para vender. Para los que empiezan y para los que quieren crecer.' : 'A US company, a professional online presence, and everything ready to sell. For those just starting and those ready to grow.'}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row hero-ctas" style={{
            gap: '12px',
            marginBottom: '32px'
          }} data-id="element-286">
              <a href="https://wa.me/message/GE4ZJ6YCJB3LE1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center transition-all" style={{
              background: '#5a4579',
              color: '#FFFFFF',
              borderRadius: '10px',
              padding: '15px 28px',
              fontSize: '15px',
              fontWeight: 700,
              gap: '8px',
              minHeight: '48px',
              boxShadow: '0 6px 20px rgba(90,69,121,0.25)'
            }} onMouseEnter={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = 'translateY(-2px)';
              el.style.boxShadow = '0 12px 28px rgba(90,69,121,0.38)';
            }} onMouseLeave={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.transform = 'translateY(0)';
              el.style.boxShadow = '0 6px 20px rgba(90,69,121,0.25)';
            }} data-id="element-287">
                {lang === 'es' ? 'Crear mi negocio' : 'Create my business'}
                <ArrowRight size={18} strokeWidth={2.2} data-id="element-288" />
              </a>
              <a href="#digital-upgrade" className="inline-flex items-center justify-center transition-all" style={{
              background: 'transparent',
              color: '#5a4579',
              borderRadius: '10px',
              padding: '15px 28px',
              fontSize: '15px',
              fontWeight: 700,
              gap: '8px',
              minHeight: '48px',
              border: '0.5px solid rgba(90,69,121,0.32)'
            }} onMouseEnter={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.background = 'rgba(90,69,121,0.06)';
              el.style.borderColor = '#5a4579';
            }} onMouseLeave={e => {
              const el = e.currentTarget as HTMLAnchorElement;
              el.style.background = 'transparent';
              el.style.borderColor = 'rgba(90,69,121,0.32)';
            }} data-id="element-289">
                {lang === 'es' ? 'Mejorar mi presencia digital' : 'Improve my digital presence'}
              </a>
            </div>

            {/* Stats */}
            <div style={{
            borderTop: '1px solid rgba(90,69,121,0.12)',
            paddingTop: '20px'
          }} data-id="element-290">
              <div className="flex flex-wrap items-center hero-stats" style={{
              gap: '0'
            }} data-id="element-291">
                {stats.map((s, i) => <Fragment key={i} data-id="element-292">
                    <div style={{
                  paddingRight: i === stats.length - 1 ? 0 : '14px',
                  paddingLeft: i === 0 ? 0 : '14px'
                }} data-id="element-293">
                      <div style={{
                    fontSize: '17px',
                    fontWeight: 800,
                    color: '#1a1020',
                    lineHeight: 1.1
                  }} data-id="element-294">
                        {s.value}
                      </div>
                      <div style={{
                    fontSize: '11px',
                    color: '#6b5f78',
                    marginTop: '2px'
                  }} data-id="element-295">
                        {s.label}
                      </div>
                    </div>
                    {i < stats.length - 1 && <div aria-hidden="true" style={{
                  width: '1px',
                  height: '32px',
                  background: 'rgba(90,69,121,0.12)'
                }} data-id="element-296" />}
                  </Fragment>)}
              </div>
            </div>
          </motion.div>

          {/* RIGHT — UI Panel (DESKTOP ONLY) */}
          <div className="hidden md:block" data-id="element-297">
            <ClientPanelCard showNotification={true} data-id="element-298" />
          </div>
        </div>
      </div>
    </section>;
}